import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {setNotification} from '@store/actions/global.actions';
import {logout} from '@store/actions/authentication.action';
import {resetTokensExpire} from '@store/actions/storage.action';
import {isPlatformBrowser} from "@angular/common";
import {DomSanitizer} from "@angular/platform-browser";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    isBrowser: boolean;

    constructor(private store: Store<AppState>, @Inject(PLATFORM_ID) platformId: Object, private sanitizer: DomSanitizer) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    handleApiError(request: string, response: string, errorType: string, errorMsg: string) {
        if (errorType == 'FORBIDDEN') {
            this.store.dispatch(setNotification({
                notification: 'Leider haben Sie für diese Anfrage keine Authentifizierung.<br>Bitte loggen Sie sich erneut ein.',
                notificationType: 'error'
            }));
            this.store.dispatch(logout());
        } else {
            this.store.dispatch(
                setNotification({
                    notification: '<b>' + errorType + "</b><br> " + errorMsg + "<br><br><b class=\"is-block mb-1\">Request-Body</b>" + this.prepareJSON(request) + '<br><b class="mb-1 is-block">Response-Body</b>' + this.prepareJSON(response) + '',
                    notificationType: 'error'
                })
            );
        }
    }

    prepareJSON(jsonString: any) {
        let string;
        try {
            string = '<pre>' + JSON.stringify(JSON.parse(jsonString), null, 4) + '</pre>';
        } catch (e) {
            string = jsonString;
        }
        return string;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(!this.isBrowser){
            return next.handle(request);
        }
        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // Es handelt sich um ein Batch
                    if (event.body.length &&
                        event.body.length > 1) {
                        event.body.map((r: { id: null | string, error?: { type: string, message: string }; }) => {
                            if (r.error &&
                                r.id?.indexOf('#INVALID_PARAMS') == -1) {
                                this.handleApiError(request.body, JSON.stringify(r), r.error.type ?? 'unknown error', r.error.message ?? '');
                            }
                        });
                        // Einzelner Request
                    } else if (event.body?.error &&
                        event.body.id?.indexOf('#INVALID_PARAMS') == -1) {
                        this.handleApiError(request.body, JSON.stringify(event.body), event.body.error.type ?? 'unknown error', event.body.error.message ?? '');
                    }
                }
            }),
            catchError((e: HttpErrorResponse, x) => {
                console.log(e);
                console.log(request);
                if (e.status == 401) {
                    this.store.dispatch(resetTokensExpire());
                }
                let msg: string = '';
                if (e.error?.text) {
                    msg = '<b>' + e.error?.error?.message + '</b><br><br><b class="mb-1 is-block">Response</b>' + this.prepareJSON(e.error?.text) + '<br><b class="is-block mb-1">Request-Body</b>' + this.prepareJSON(request.body);
                } else if (e.error?.error?.type) {
                    msg = '<b>' + e.error.error.type + '<br>' + e.error.error.message;
                } else {
                    msg = '<b>EMPTY RESPONSE</b><br><br><b class="is-block mb-1">Request-Body</b>' + this.prepareJSON(request.body)
                }

                if (e?.status == 504) {
                    msg = '<b>Keine Verbindung zum Server.</b><br>' + e?.message;
                }
                /*if(e?.status == 401 || e?.status == 403){
                    msg = '<b>Leider haben Sie für diese Anfrage keine Authentifizierung.</b><br>' + e?.message;
                }*/
                this.store.dispatch(
                    setNotification({
                        notification: msg,
                        notificationType: 'error'
                    })
                );
                /*if (this.isBrowser) {
                    setTimeout(() => {
                        writeErrorToHTMLIfAppNotInitialized(this.sanitizer.sanitize(SecurityContext.HTML, msg)?.toString() ?? '');
                    }, 100);
                }*/
                return throwError(() => {
                    return {message: msg}
                })
            })
        );
    }
}
